import React from 'react';
import styles from './AgentChat.styles';
import { AgentIcon } from '../../Header/Icons';
import { isEmpty } from 'validator';
import { Icon } from '@material-ui/core';
import { AgentChatMessageType } from '../Agent.types';

interface AgentChatProps {
  type: AgentChatMessageType;
  message: string;
}

export const AgentChat: React.FC<AgentChatProps> = ({ type, message }) => {
  let lines: string[] = [];
  if (!isEmpty(message)) {
    lines = message.split('\n').map((i) => i.trim());
  }
  return (
    <div className={type === AgentChatMessageType.user ? styles.userMessageRow : styles.aiMessageRow}>
      {type === AgentChatMessageType.agent && (
        <div className={styles.aiIcon}>
          <AgentIcon />
        </div>
      )}
      <div className={type === AgentChatMessageType.user ? styles.userMessageBubble : styles.aiMessageText}>
        {lines.map((l) => {
          if (l === '<hr>') {
            return <hr />;
          }
          return <div style={{ minHeight: 10 }}>{l}</div>;
        })}
      </div>
      {type === AgentChatMessageType.user && (
        <div className={styles.aiIcon}>
          <Icon className="fas fa-user user" />
        </div>
      )}
    </div>
  );
};
